import { useLocation, matchPath } from 'react-router-dom';
import Dashboard from '../layouts/admin';
import routes from '../routes';
import NotFoundPage from 'views/404/NotFoundPage';

export default function AdminWrapper() {
  const location = useLocation();
  const adminRoutes = routes.filter((r) => r.layout === '/admin');

  const isValid = adminRoutes.some((route) => {
    const fullPath = `/admin${route?.path}`;
    return matchPath({ path: fullPath, end: false }, location.pathname);
  });

  return isValid ? <Dashboard /> : <NotFoundPage />;
}
